import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        const phoneNumber = '918308303159';
        const message = 'Welcome to Shivpratap Multistate on WhatsApp feel free to reach out here';
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        window.open(whatsappUrl, '_blank');
    };

    return (
        <div
            className="fixed bottom-6 right-6 z-50 cursor-pointer"
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                transition: 'all 0.3s ease-in-out'
            }}
        >
            {/* Tooltip */}
            {isHovered && (
                <div
                    className="absolute bottom-full right-0 mb-2 px-4 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg whitespace-nowrap"
                    style={{
                        animation: 'fadeIn 0.3s ease-in-out'
                    }}
                >
                    Chat with us on WhatsApp
                    <div
                        className="absolute top-full right-4 w-0 h-0"
                        style={{
                            borderLeft: '6px solid transparent',
                            borderRight: '6px solid transparent',
                            borderTop: '6px solid #1f2937'
                        }}
                    />
                </div>
            )}

            {/* WhatsApp Button */}
            <div
                className="flex items-center justify-center w-16 h-16 rounded-full shadow-2xl"
                style={{
                    backgroundColor: '#25D366',
                    transform: isHovered ? 'scale(1.1)' : 'scale(1)',
                    transition: 'transform 0.3s ease-in-out',
                    boxShadow: isHovered
                        ? '0 10px 30px rgba(37, 211, 102, 0.5)'
                        : '0 4px 15px rgba(0, 0, 0, 0.3)'
                }}
            >
                <FaWhatsapp
                    className="text-white"
                    style={{
                        fontSize: '2rem',
                        animation: isHovered ? 'pulse 1s infinite' : 'none'
                    }}
                />
            </div>

            {/* Ripple effect */}
            {!isHovered && (
                <div
                    className="absolute inset-0 rounded-full"
                    style={{
                        backgroundColor: '#25D366',
                        opacity: 0.3,
                        animation: 'ripple 2s infinite'
                    }}
                />
            )}

            <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes ripple {
          0% {
            transform: scale(1);
            opacity: 0.3;
          }
          50% {
            transform: scale(1.2);
            opacity: 0.1;
          }
          100% {
            transform: scale(1);
            opacity: 0.3;
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
        </div>
    );
};

export default WhatsAppButton;
